import { ScoreWithTooltip } from '@/components/ui/ScoreWithTooltip';
import { StatusGroup } from '@/components/ui/StatusGroup';
import type { StatusPillStatus } from '@/components/ui/StatusPill';
import { cx } from '@/cva.config';
import { breakdownFromJob } from '@/lib/jobAdapter';
import { formatSalary } from '@/lib/score';
import type { Job } from '@/types/job.type';

interface TrackerListRowProps {
  job: Job;
  onSelect: (id: number) => void;
}

export const TrackerListRow = ({ job, onSelect }: TrackerListRowProps) => {
  const salary = formatSalary(job.salaryMin, job.salaryMax);
  const breakdown = breakdownFromJob(job);

  return (
    <button
      className="grid cursor-pointer grid-cols-[96px_2fr_1fr_110px_110px_240px] items-center gap-4 px-5 py-2.5 transition-colors hover:bg-border/20"
      onClick={() => onSelect(job.id)}
      type="button"
    >
      <ScoreWithTooltip breakdown={breakdown} score={job.matchScore} />
      <div className="min-w-0">
        <p className="truncate text-sm lg:text-base font-medium">{job.title}</p>
        <p className="truncate text-xs lg:text-sm text-foreground-muted">
          {job.company}
        </p>
      </div>
      <span className="truncate text-xs lg:text-sm text-foreground-muted">
        {job.location ?? '—'}
      </span>
      <span
        className={cx(
          'font-mono text-xs lg:text-sm whitespace-nowrap tabular-nums',
          salary ? 'text-score-high' : 'text-subtle',
        )}
      >
        {salary ?? '—'}
      </span>
      <span className="font-mono text-2xs lg:text-xs tracking-wide text-subtle uppercase">
        {job.source}
      </span>
      <div className="flex justify-end">
        <StatusGroup
          appStatus={
            job.appStatus ? (job.appStatus as StatusPillStatus) : undefined
          }
          jobStatus={job.status as StatusPillStatus}
        />
      </div>
    </button>
  );
};
